require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/browse/workshoppaginationbutton.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/browse/workshoppaginationbutton.legacy.js
// module id = 638
// module chunks = 31